import { isApple } from './get_os.js';

export function isPrimaryModifierKey(event: {
  metaKey: boolean;
  ctrlKey: boolean;
}) {
  return isApple ? event.metaKey : event.ctrlKey;
}
